var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3226 28.3067L43.31 28.307C43.1478 26.0445 41.2618 24.2579 38.9574 24.2579C38.1948 24.2579 37.4781 24.454 36.8547 24.7974C35.3646 21.9468 32.3817 20 28.9417 20C24.1059 20 20.1711 23.8464 20.0235 28.6465C16.6527 28.9144 14 31.7327 14 35.1721C14 38.788 16.9317 40.8145 20.5483 40.8145H36.519C36.1166 39.8805 35.8925 38.8526 35.8925 37.774C35.8925 33.5242 39.35 30.0673 43.5992 30.0673C46.2627 30.0673 48.6154 31.4267 50 33.4871C49.6864 30.075 46.8179 28.3067 43.3226 28.3067ZM25.0498 24.8924C24.9991 24.9344 24.9484 24.9767 24.9008 25.0228C24.7134 25.2039 24.5393 25.3948 24.4029 25.6179C23.8802 26.4724 23.7809 27.3881 23.8953 28.3727C24.0054 29.3191 22.5244 29.3086 22.416 28.3727C22.2125 26.6238 22.7719 24.6501 24.2967 23.6204C25.0876 23.0851 25.8245 24.3585 25.0498 24.8924ZM25.0344 24.9033C24.9557 24.9683 25.0012 24.9277 25.0344 24.9033V24.9033Z",
    fill: "#2563EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5708 44C45.2177 44 46.7971 43.3458 47.9616 42.1813C49.1261 41.0168 49.7803 39.4373 49.7803 37.7905C49.7803 36.1436 49.1261 34.5642 47.9616 33.3997C46.7971 32.2351 45.2177 31.5809 43.5708 31.5809C41.9239 31.5809 40.3445 32.2351 39.18 33.3997C38.0155 34.5642 37.3613 36.1436 37.3613 37.7905C37.3613 39.4373 38.0155 41.0168 39.18 42.1813C40.3445 43.3458 41.9239 44 43.5708 44ZM46.4482 37.2417L44.1196 34.9131C43.974 34.7676 43.7766 34.6859 43.5708 34.6859C43.365 34.6859 43.1676 34.7676 43.022 34.9131L40.6935 37.2417C40.5521 37.3881 40.4738 37.5842 40.4756 37.7877C40.4774 37.9912 40.559 38.1859 40.7029 38.3298C40.8468 38.4737 41.0415 38.5553 41.245 38.5571C41.4485 38.5589 41.6446 38.4806 41.791 38.3392L42.7946 37.3356V40.119C42.7946 40.3249 42.8764 40.5223 43.022 40.6679C43.1675 40.8135 43.365 40.8952 43.5708 40.8952C43.7767 40.8952 43.9741 40.8135 44.1197 40.6679C44.2652 40.5223 44.347 40.3249 44.347 40.119V37.3356L45.3506 38.3392C45.497 38.4806 45.6931 38.5589 45.8966 38.5571C46.1001 38.5553 46.2948 38.4737 46.4387 38.3298C46.5826 38.1859 46.6642 37.9912 46.666 37.7877C46.6678 37.5842 46.5895 37.3881 46.4482 37.2417Z",
    fill: "#2563EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDrop);
export default __webpack_public_path__ + "static/media/DragDrop.ce54a5ff87e3d5b967b124452906657a.svg";
export { ForwardRef as ReactComponent };